import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
    font-family: "Satoshi", sans-serif;
  }

  html {
    height: 100%;
  }

  body {
    -webkit-font-smoothing: antialiased;
    font-size: 16px;
    background-color: ${(props) =>
      props.theme.color.background.neutral.default};
    height: 100%;
  }

  #root {
    height: 100%;
  }

  a {
    text-decoration: none;
  }

  img {
    max-width: 100%;
  }
`;

export default GlobalStyle;
